<script setup>
const screenTransparent = new URLSearchParams(window.location.search).has('screenTransparent')
</script>

<template>
  <div class="w-full h-full" :class="{ 'bg-q-cr-red-primary': !screenTransparent }">
    <slot />
  </div>
</template>
